module.exports = __webpack_public_path__ + "img/zhangjin.e0d9301c.jpg";